// src/pages/factors/FactorItemsTable.jsx
import React, { useRef } from 'react';
import ProductPicker from './ProductPicker';
import { parseNum, formatNumber, fmt, calcTotals } from '../../utils/factorHelpers';

export default function FactorItemsTable({
  items,
  setItems,
  onChange,
}) {
  /* ============== تغییر یک فیلد ============== */
  const updateItem = (index, field, value) => {
    setItems((prev) => {
      const copy = [...prev];
      copy[index] = { ...copy[index], [field]: value };
      return copy;
    });
    onChange?.();
  };
  const priceRefs = useRef({});
  /* ============== انتخاب محصول از dropdown ============== */
  const handleProductSelect = (index, product) => {
    setItems((prev) => {
      const copy = [...prev];
      copy[index] = {
        ...copy[index],
        code: product.code || '',
        name: product.name || '',
        unit: product.unit || '',
        price: Number(product.price) || 0,
          description: product.description || '',

      };
      return copy;
    });
    onChange?.();

    // فوکوس و انتخاب متن قیمت (بعد از رندر)
    setTimeout(() => {
      const el = priceRefs.current[index];
      if (el) {
        el.focus();
        el.select();
      }
    }, 0);
  };

  /* ============== افزودن / حذف ============== */
  const addItem = () => {
    setItems((prev) => [
      ...prev,
      {
        _key: Math.random().toString(36).slice(2),
        code: '',
        name: '',
        unit: '',
          description: '',
        qty: 1,
        price: 0,
        discount: 0,
        hasTax: false,
      },
    ]);
    onChange?.();
  };

  const removeItem = (index) => {
    setItems((prev) => prev.filter((_, i) => i !== index));
    onChange?.();
  };

  /* ============== محاسبات ============== */
  const normalized = items.map((it) => ({
    qty: parseNum(it.qty),
    price: parseNum(it.price),
    discount: parseNum(it.discount),
    tax: it.hasTax
      ? Math.round(
          (parseNum(it.qty) * parseNum(it.price) -
            parseNum(it.discount)) *
            0.1
        )
      : 0,
  }));

  const totals = calcTotals(normalized);

  /* ============== Render ============== */
  return (
    <>
      <div className="overflow">
        <table id="itemsTable">
          <thead>
            <tr>
              <th>ردیف</th>
              <th>کالا</th>
              <th>واحد</th>
              <th>تعداد</th>
              <th>مبلغ واحد (ریال)</th>
              <th>تخفیف (ریال)</th>
              <th>مالیات و عوارض ۱۰٪</th>
              <th>جمع کل (ریال)</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {items.map((it, i) => {
              const qty = parseNum(it.qty);
              const price = parseNum(it.price);
              const disc = parseNum(it.discount);
              const beforeTax = qty * price - disc;
              const lineTax = it.hasTax ? beforeTax * 0.1 : 0;
              const lineTotal = beforeTax + lineTax;

              return (
                <tr key={it._key || i}>
                  <td className="rowIndex">{i + 1}</td>
             <td style={{ minWidth: 180 }}>
  <ProductPicker
    value={it.name || ''}
    onSelect={(p) => handleProductSelect(i, p)}
    onManualChange={(text) => { /* همون قبلی */ }}
  />
  <input
    value={it.description || ''}
    onChange={(e) => updateItem(i, 'description', e.target.value)}
    placeholder="توضیحات (اختیاری)"
    autoComplete="off"
    style={{ marginTop: 6, fontSize: 12 }}
  />
</td>
                  <td style={{ minWidth: 70 }}>
                    <input
                      value={it.unit || ''}
                      onChange={(e) =>
                        updateItem(i, 'unit', e.target.value)
                      }
                    />
                  </td>
                  <td style={{ minWidth: 60 }}>
                    <input
                      type="number"
                      value={it.qty}
                      onChange={(e) =>
                        updateItem(i, 'qty', e.target.value)
                      }
                      min="1"
                    />
                  </td>
                  <td style={{ minWidth: 90 }}>
                    <input
                      ref={(el) => (priceRefs.current[i] = el)}
                      type="text"
                      inputMode="numeric"
                      value={formatNumber(parseNum(it.price))}
                      onChange={(e) =>
                        updateItem(i, 'price', parseNum(e.target.value))
                      }
                    />
                  </td>
                  <td style={{ minWidth: 90 }}>
                    <input
                      type="text"
                      inputMode="numeric"
                      value={formatNumber(parseNum(it.discount))}
                      onChange={(e) =>
                        updateItem(
                          i,
                          'discount',
                          parseNum(e.target.value)
                        )
                      }
                    />
                  </td>
                  <td
                    style={{
                      minWidth: 90,
                      textAlign: 'center',
                    }}
                  >
                    <label
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 6,
                        cursor: 'pointer',
                        fontSize: 12,
                        color: 'var(--muted)',
                        margin: 0,
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={!!it.hasTax}
                        onChange={(e) =>
                          updateItem(i, 'hasTax', e.target.checked)
                        }
                        style={{
                          width: 16,
                          height: 16,
                          accentColor: 'var(--accent)',
                        }}
                      />
                      <span>۱۰٪</span>
                    </label>
                  </td>
                  <td className="lineTotal">{fmt(lineTotal)}</td>
                  <td>
                    <button
                      type="button"
                      className="btn danger small"
                      onClick={() => removeItem(i)}
                      aria-label="حذف ردیف"
                    >
                      <i className="fa-solid fa-xmark" />
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="flexend">
        <button
          className="btn secondary small"
          type="button"
          onClick={addItem}
        >
          <i className="fa-solid fa-plus" /> ردیف جدید
        </button>
      </div>

      <div className="total-box">
        <table className="total-table">
          <tbody>
            <tr>
              <td>جمع کل قبل از تخفیف/مالیات</td>
              <td>{fmt(totals.sub)}</td>
            </tr>
            <tr>
              <td>جمع تخفیف</td>
              <td>{fmt(totals.disc)}</td>
            </tr>
            <tr>
              <td>جمع مالیات و عوارض</td>
              <td>{fmt(totals.tax)}</td>
            </tr>
            <tr>
              <td>
                <b>مبلغ نهایی قابل پرداخت</b>
              </td>
              <td>
                <b>{fmt(totals.total)}</b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}
